export interface Announcement {
  id: string;           // Unique ID (used for localStorage tracking)
  title: string;        // Short title
  description: string;  // Detailed message
  type: 'info' | 'success' | 'warning';  // Ant Design Alert type
  date: string;         // When announced (for display)
  linkText?: string;    // Optional CTA button text
  linkPath?: string;    // Optional navigation path (e.g., '/operations')
}

export const ANNOUNCEMENTS: Announcement[] = [
  {
    id: 'barrier-reset-feature-2024-01-30',
    title: 'New: Barrier Reset for FAULT Slots',
    description: 'You can now reset faulty barriers directly from the Operations page. Click on any slot showing FAULT status to access the reset procedure.',
    type: 'info',
    date: '2024-01-30',
    // linkText: 'Go to Operations',
    // linkPath: '/operations',
  },
   // Add future announcements here...
];


// annoucement template

//   {
//     id: '', // Unique ID (used for localStorage tracking)
//     title: '', // Short title
//     description: '', // Detailed message
//     type: 'info', // 'info' | 'success' | 'warning' (Ant Design Alert type)
//     date: '', // AAAA-MM-DD format
//     linkText: '', // Optional clickleable button text
//     linkPath: '', // Optional navigation path (e.g., '/operations')
//   },
//   // Add future announcements here...